(function() {
'use strict';

const TR = angular.module('TR');
TR.directive('translateKey', function(reviewService) {
    return {
        restrict: 'A',
        link(scope, el, attr) {
            reviewService.setTranslationKey(attr.translateKey);
        }
    };
});
})();
